<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card id="billdata">
          <div class="row">
                    <div class="col-sm-6"><img src="images/logo.jpg" width="200" height="43"></div>
                    <div class="col-sm-6">
                    <div class="text-center">
                          <barcode v-bind:value="guia != null ? guia.guia_interna : ''"  v-bind:height="25">
                            Error al generar barcode
                          </barcode>
                    </div>
                    </div>
          </div>
          <div class="row" style="font-size:x-small">
            <div class="col-sm-6">
              <div>
                <h4
                  v-if="guia.tipoguia != 'importacion'"
                  style="font-weight: bold"
                >
                  Enviador
                </h4>
                <h6 v-else style="font-weight: bold">Recogido desde:</h6>
                <div id="s1">
                  <label style="font-weight: bold">Empresa:</label>
                  {{ guia.empresa_e }}
                </div>
                <div id="s2">
                  <label style="font-weight: bold">Contacto:</label>
                  {{ guia.contacto_e }}
                </div>
                <div id="s21">
                  <label style="font-weight: bold">Correo:</label>
                  {{ guia.correo_e }}
                </div>
                <div id="s22">
                  <label style="font-weight: bold">RUC/VAT ID:</label>
                  {{ guia.nit_e }}
                </div>
                <div id="s3">
                  <label style="font-weight: bold">Dirección:</label>
                  {{ guia.direccion1_e }} {{ guia.direccion2_e }}
                  {{ guia.direccion3_e }}
                </div>
                <div id="s6">
                  <label style="font-weight: bold">País:</label>
                  {{ guia.pais_e }}
                </div>
                <div id="s7">
                  <label style="font-weight: bold">Ciudad:</label>
                  {{ guia.ciudad_e }}
                </div>
                <div id="s72">
                  <label style="font-weight: bold">Código Postal:</label>
                  {{ guia.zip_e }}
                </div>
                <div id="s8">
                  <label style="font-weight: bold">Teléfono:</label>
                  {{ guia.telefono_e }}
                </div>
              </div>
            </div>
            <div class="col-sm-6">
              <h4 style="font-weight: bold">Consignatario:</h4>
              <div id="c1">
                <label style="font-weight: bold">Empresa:</label>
                {{ guia.empresa_c }}
              </div>
              <div id="c2">
                <label style="font-weight: bold">Contacto:</label>
                {{ guia.contacto_c }}
              </div>
              <div id="c21">
                  <label style="font-weight: bold">Correo:</label>
                  {{ guia.correo_c }}
                </div>
                <div id="c22">
                  <label style="font-weight: bold">RUC/VAT ID:</label>
                  {{ guia.nit_c }}
                </div>
              <div id="c3">
                <label style="font-weight: bold">Dirección:</label>
                {{ guia.direccion1_c }} {{ guia.direccion2_c }}
                {{ guia.direccion3_c }}
              </div>
              <div id="c6">
                <label style="font-weight: bold">País:</label> {{ guia.pais_c }}
              </div>
              <div id="c7">
                <label style="font-weight: bold">Ciudad:</label>
                {{ guia.ciudad_c }}
              </div>
              <div id="c7">
                <label style="font-weight: bold">Código Postal:</label>
                {{ guia.zip_c }}
              </div>
              <div id="c8">
                <label style="font-weight: bold">Teléfono:</label>
                {{ guia.telefono_c }}
              </div>
            </div>
          </div>

          <div class="row" style="font-size:x-small">
            <div class="col-sm-6">
              <h4 style="font-weight: bold">Detalles del envío:</h4>
              <div>
                <label style="font-weight: bold">Fecha:</label
                ><span> {{ formatedDate }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Número de guía:</label
                ><span> {{ guia.guia_interna }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Tipo de servicio:</label
                ><span> {{ guia.servicio }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Número de piezas:</label
                ><span> {{ guia.piezas }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Peso Total: </label
                ><span> {{ guia.peso }} {{ guia.unidad_m }}</span>
              </div>
            </div>
            <div class="col-sm-6">
              <h4 style="color: white">.</h4>
              <div>
                <label style="font-weight: bold">Valor declarado: </label
                ><span> {{ guia.valor }} {{ guia.moneda }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Tipo: </label
                ><span> {{ guia.tipo }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Descripción: </label
                ><span> {{ guia.descripcion }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Incoterms: </label
                ><span> {{ guia.incoterms }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Seguro: </label
                ><span> {{ guia.seguro }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Guia Agente: </label
                ><span> {{ guia.guia_proveedor }}</span>
              </div>
            </div>
          </div>

          <div class="row" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Piezas
              </h4>
              <table class="table" style="font-size:x-small">
                <thead>
                    <tr>
                        <th>Piezas</th>
                        <th>Peso</th>
                        <th>UM</th>
                        <th>Largo</th>
                        <th>Ancho</th>
                        <th>Alto</th>
                        <th>UM</th>
                        <th>Peso Total</th>
                        <th>Volumen Total</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(pieza, index) in guia.paquetes" :key="index">
                        <td>{{pieza.piezas}}</td>
                        <td>{{pieza.peso}}</td>
                        <td>{{pieza.unidad_peso}}</td>
                        <td>{{pieza.largo}}</td>
                        <td>{{pieza.ancho}}</td>
                        <td>{{pieza.alto}}</td>
                        <td>{{pieza.unidad_medida}}</td>
                        <td>{{pieza.pesototal}}</td>
                        <td>{{pieza.volumentotal}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
          </div>

          <div class="row" style="font-size:x-small" v-if="guia.factura == 'Crear'">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Items Factura
              </h4>
              <table class="table" style="font-size:x-small">
                <thead>
                    <tr>
                        <th>Descripcion</th>
                        <th>Cantidad</th>
                        <th>Unidad</th>
                        <th>Arancel</th>
                        <th>Peso Neto</th>
                        <th>Peso Bruto</th>
                        <th>Costo</th>
                        <th>Total</th>
                        <th>Origen</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in guia.items" :key="index">
                        <td>{{item.descripcion}}</td>
                        <td>{{item.cantidad}}</td>
                        <td>{{item.unidad}}</td>
                        <td>{{item.arancel}}</td>
                        <td>{{item.peso_neto}}</td>
                        <td>{{item.peso_bruto}}</td>
                        <td>{{item.costo}}</td>
                        <td>{{item.total}}</td>
                        <td>{{item.paisfab}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
          </div>

          <div class="row" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Ciclo de Vida
              </h4>
              <table class="table" style="font-size:x-small">
                <thead>
                    <tr>
                        <th>Estatus</th>
                        <th>Fecha</th>
                        <th>Hora</th>
                        <th>Comentarios</th>
                        <th>Digitador</th>
                        <th>Creacion</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(st, index) in guia.estatuslist" :key="index">
                        <td>{{st.estatus != undefined ? st.estatus.descripcion : ''}}</td>
                        <td>{{formatDate(st.fecha + 'T00:00:00')}}</td>
                        <td>{{st.hora}}</td>
                        <td>{{st.comentarios}}</td>
                        <td>{{st.usuario != null ? st.usuario.name : ''}}</td>
                        <td>{{formatDate(st.created_at)}}</td>
                    </tr>
                </tbody>
            </table>
            </div>
          </div>

          <div class="row" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Historial Agente
              </h4>
              <table class="table" style="font-size:x-small">
                <thead>
                    <tr>
                      <th>Ciudad</th>
                      <th>Descripcion</th>
                      <th>Estado</th>
                      <th>Fecha/Hora</th>
                      <th>Transporte</th>
                      <th>Transportista</th>
                    </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="(dt, index) in datosTrackingTra"
                    :key="index"
                  >
                    <td>
                      {{dt.ciudad}}
                    </td>
                    <td>
                      {{dt.descripcion}}
                    </td>
                    <td>{{dt.estado}}</td>
                    <td>{{dt.fechaHora}}</td>
                    <td>
                      {{dt.transporte}}
                    </td>
                    <td>
                      {{dt.transportista}}
                    </td>
                  </tr>
                </tbody>
            </table>
            </div>
          </div>

          <div class="row" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Prueba de Entrega
              </h4>
              <div>
                <label style="font-weight: bold">Fecha: </label
                ><span> {{  guia.podfecha != null ? formatDate(guia.podfecha + 'T00:00:00') : null }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Hora: </label
                ><span> {{ guia.podhora }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Recibido Por: </label
                ><span> {{ guia.podnombre }}</span>
              </div>
            </div>
          </div>
          <v-divider vertical v-if="guia.tipoguia != 'nacional'"></v-divider>
          <div class="row" v-if="guia.tipoguia != 'nacional'" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                UNDEL
              </h4>
              <div>
                <label style="font-weight: bold">Fecha: </label
                ><span> {{  guia.undel_fecha != null ? formatDate(guia.undel_fecha) : null }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Motivos: </label
                ><span v-for="(motivoundel,key) in guia.motivosundellist" :key="key"> {{ motivoundel.motivo.motivo}} {{motivoundel.observacion != null ? '(' + motivoundel.observacion + ')': ''}},</span>
              </div>
              <div>
                <label style="font-weight: bold">Solución: </label
                ><span> {{ guia.undel_solucion }}</span>
              </div>
              <div>
                <label style="font-weight: bold">Fecha Solución: </label
                ><span> {{ guia.undel_fechasolucion != null ? formatDate(guia.undel_fechasolucion) : null }}</span>
              </div>
            </div>
          </div>
          <v-divider vertical v-if="guia.tipoguia != 'nacional'"></v-divider>
          <div class="row" v-if="guia.tipoguia != 'nacional'" style="font-size:x-small">
            <div class="col-sm-12">
              <h4 style="font-weight: bold">
                Seguro
              </h4>
              <div>
                <label style="font-weight: bold">Agente Asegurador: </label
                ><span> {{  guia.agenteasegurador != null ? guia.agenteasegurador.nombre : '' }}</span>
              </div>
              <div>
                <label style="font-weight: bold">No Aplicación: </label
                ><span> {{ guia.seg_no_aplicacion }}</span>
              </div>
              <div>
                <table class="table" style="font-size:x-small">
                    <thead>
                        <tr>
                            <th>Valor Contenido</th>
                            <th>Flete Internacional</th>
                            <th>Flete Nacional</th>
                            <th>Valor Total</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>${{guia.seg_valor_contenido}}</td>
                            <td>${{guia.seg_flete_int}}</td>
                            <td>${{guia.seg_flete_nac}}</td>
                            <td>${{guia.seg_valor_total}}</td>
                        </tr>
                    </tbody>
                </table>
              </div>
            </div>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <v-card class="text-right">
          <v-spacer></v-spacer
          ><v-btn color="blue" dark @click="imprimirGuia()">Imprimir</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import VueBarcode from 'vue-barcode';
import $ from "jquery";
import apicon from "../plugins/apicon";
import utils from "../utils/utils";
export default {
  props: {
    id: {
      type: Number,
      default: null,
    },
  },
  components:{
    'barcode': VueBarcode
  },
  created: function () {},
  data() {
    return {
      guia: null,
      piezas:[],
      movimientos: [],
      empresa: null,
      isCliente: 1,
      formatedDate: null,
      datosTrackingTra: [],
    };
  },
  methods: {
    fillDatosGuia: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "guias/" + this.id)
        .then((result) => {
          this.guia = result;
        });
    },
    consultarTrackingTramaco:async function(){
        await apicon.getDataApi(apicon.getApiBaseUrl() + "rastrearguiatramaco/" + this.guia.guia_proveedor).then((result) => {
          this.datosTrackingTra = result.lstSalidaTrackGuiaWs;
        });
      },
    fillDatosEmpresa: async function () {
      await apicon
        .getDataApi(apicon.getApiBaseUrl() + "empresa/1")
        .then((result) => {
          this.empresa = result;
        });
    },
    imprimirGuia: function () {
      var mywindow = window.open("", "tracking div", "height=400,width=600");
      mywindow.document.write(
        '<html><head><link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/3.3.6/css/bootstrap.min.css"><link rel="stylesheet" href="css/print.css" media="print" /><link rel="stylesheet" href="css/bootstrap-print.min.css" media="print"/></head><body onload="window.print()">'
      );
      mywindow.document.write($("#billdata").html());
      mywindow.document.write("</body></html>");
      mywindow.document.close(); // necessary for IE >= 10
      mywindow.focus(); // necessary for IE >= 10
      setTimeout(function () {
        mywindow.close();
      }, 1000);
    },
    formatDate: function(date){
      return utils.formatDate(date);
    },
  },
  mounted: async function () {
    apicon.setAuthHeaders();
    await this.fillDatosGuia();
    await this.fillDatosEmpresa();
    this.isCliente = localStorage.getItem("cliente");
    this.formatedDate = utils.formatDate(this.guia.created_at);
    await this.consultarTrackingTramaco();
  },
};
</script>
<style scoped src="bootstrap/dist/css/bootstrap.css">

</style>
